import React from "react";
import { motion } from "framer-motion";
import Button from "./Button";

export default function CTA() {
  return (
    <section
      className="relative py-24 md:py-36 overflow-hidden"
      data-testid="cta-section"
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-purpleDeep via-brand-purple to-brand-orange" />
        <div className="absolute -top-40 -left-20 w-[600px] h-[600px] rounded-full bg-brand-purpleLight/30 blur-3xl" />
        <div className="noise-overlay opacity-60" />
      </div>
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/25 bg-white/15 backdrop-blur">
            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulseGlow" />
            <span className="font-display text-[11px] uppercase tracking-[0.28em] text-white font-bold">
              Ready to run better hotels
            </span>
          </div>
          <h2
            className="mt-8 font-display text-white text-[46px] md:text-[86px] leading-[0.98] tracking-tight text-balance"
            style={{ fontWeight: 800 }}
          >
            Let&apos;s <span className="grad-text-orange">hotel</span>.
          </h2>
          <p className="mt-6 text-white/90 text-[17px] md:text-[19px] leading-relaxed max-w-2xl mx-auto">
            Book a 30-minute walkthrough with our team. See the platform on
            your property in under a week.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Button to="/demo" variant="primary" testId="cta-book-demo-btn">
              Book demo
            </Button>
            <Button to="/contact" variant="secondary" testId="cta-contact-btn">
              Talk to sales
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
